import { render, staticRenderFns } from "./professionalManagement.vue?vue&type=template&id=039f303c&scoped=true"
import script from "./professionalManagement.vue?vue&type=script&lang=js"
export * from "./professionalManagement.vue?vue&type=script&lang=js"
import style0 from "./professionalManagement.vue?vue&type=style&index=0&id=039f303c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f303c",
  null
  
)

export default component.exports